<template>
  <div class="invitations">
    <swiper ref="mySwiper" class="swiper-wrapper" :options="swiperOptions">
      <swiper-slide class="step1">
        <div class="status">
          <svg-icon :icon-class="meetingInfo.meetingStatus" />
        </div>
        <div class="content">
          <div class="head">
            <svg-icon icon-class="invitation_head_2" />
          </div>
          <div class="theme">
            {{ meetingInfo.theme }}
          </div>
          <div class="footer">
            <div class="box">
              <div class="item">
                <svg-icon icon-class="invitation_time" />
                <div class="value">{{ meetingInfo.startTime }} ~ {{ meetingInfo.endTime }}</div>
              </div>
              <div class="item address">
                <svg-icon icon-class="invitation_address" />
                <div class="value">{{ meetingInfo.meetingRoomLocation }}{{ meetingInfo.meetingRoomName }}</div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide v-if="meetingInfo.meetingContent" class="step2">
        <div class="content">
          <div class="left" />
          <div>
            <div class="up">会议简介</div>
            <div class="down">MEETING OVERVIEW</div>
          </div>
          <div class="right" />
        </div>
        <div class="value" style="word-break: break-all; word-wrap: break-word;">
          {{ meetingInfo.meetingContent }}
        </div>
      </swiper-slide>
      <swiper-slide v-if="meetingInfo.agendasList.length > 0" class="step3">
        <div class="content">
          <div class="left" />
          <div>
            <div class="up">会议议程</div>
            <div class="down">MEETING AGENDA</div>
          </div>
          <div class="right" />
        </div>
        <div v-if="meetingInfo.agendasList.length > 1" class="list">
          <div v-for="(item, index) in meetingInfo.agendasList" :key="index" class="dialog">
            <div class="line_up" v-if="index !== 0" />
            <div class="line_down" v-if="index !== meetingInfo.agendasList.length - 1" />
            <div class="line_icon">
              <svg-icon icon-class="invitation_ok_green" class="lineSvg" />
            </div>
            <div class="horn">
              <div class="up" />
              <div class="arrow">
                <div class="arrow-icon" />
              </div>
              <div class="down" />
            </div>
            <div class="item">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="list" v-else>
          <div style="color:#FFFFFF; font-size: 0.2rem; text-align: center; padding: 0 20px">
            {{ meetingInfo.agendasList[0] }}
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="step4">
        <div class="content">
          <div class="left" />
          <div>
            <div class="up">会议详情</div>
            <div class="down">MEETING DETAILS</div>
          </div>
          <div class="right" />
        </div>
        <div class="list">
          <div v-for="item in meetingInfo.infoList" class="item">
            <div class="name">
              <span>{{ item.name }}</span>
            </div>
            <div class="value">{{ item.value }}</div>
          </div>
          <div v-if="meetingInfo.materials.length > 0" class="item">
            <div class="name">
              <span>会议资料</span>
            </div>
            <div v-for="son in meetingInfo.materials" class="value">
              {{ filterTitle(son.materialName) }}
              <van-icon name="description" color="#6fc597" class="tag" @click="() => onCopy(son.materialUrl)" />
            </div>
          </div>
          <div v-if="!viewStatus" class="item">
            <div class="value">
              主办方：{{ meetingInfo.organization }}
            </div>
          </div>
          <div v-if="meetingInfo.coOrganization" class="item">
            <div class="organization">
              协办方：{{ meetingInfo.coOrganization }}
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="step5">
        <div v-if="filterSign()">
          <div class="content">
            <div class="left" />
            <div>
              <div class="up">参会登记</div>
              <div class="down">REGISTER TO ATTEND</div>
            </div>
            <div class="right" />
          </div>
          <div class="form">
            <div class="item">
              <div class="label">
                <span>*</span>
                姓名
              </div>
              <div class="formItem">
                <input v-model="dataForm.attendee" type="text" placeholder="请输入姓名" class="nameInput">
                <div class="gender">
                  <div :class="dataForm.gender | filterGender('MALE')" @click="() => onGender('MALE')">男</div>
                  <div :class="dataForm.gender | filterGender('FEMALE')" @click="() => onGender('FEMALE')">女</div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="label">
                <span>*</span>
                手机号
              </div>
              <div class="formItem">
                <input v-model="dataForm.phone" type="number" placeholder="请输入手机号码" class="phoneInput" @blur="onChangePhone">
              </div>
              <div v-if="showSms" class="formItem">
                <input v-model="dataForm.validCode" type="number" placeholder="请输入验证码" class="phoneInput">
                <button class="btn" @click="GetCode">{{ btnName }}</button>
              </div>
            </div>
            <div class="item">
              <div class="label">
                公司/单位
              </div>
              <div class="formItem">
                <input v-model="dataForm.company" type="text" placeholder="请输入公司/单位名称" class="phoneInput">
              </div>
            </div>
            <div class="item">
              <div class="label">
                车牌号
              </div>
              <div class="formItem">
                <input v-model="dataForm.carNumber" type="text" placeholder="请输入车牌号预约车位" class="phoneInput">
              </div>
            </div>
            <div class="item">
              <div class="label">
                头像
              </div>
              <button v-if="!dataForm.faceImg" class="uploadBtn" @click="showUpload = true"><span>+</span>上传头像</button>
              <div v-else class="img">
                <svg-icon icon-class="green_del" class="del" @click="dataForm.faceImg = ''" />
                <img :src="baseURL + dataForm.faceImg" @click="showUpload = true">
              </div>
            </div>
            <div class="item">
              <button class="confirmBtn" @click="confirmMeeting">确认参会</button>
            </div>
          </div>
        </div>
        <div v-else class="qrCode">
          <div v-if="passInfo.visitorStatus === 'WAITING_VERIFY'" class="item">
            <div class="content">
              <div class="left" />
              <div>
                <div class="up">登记成功</div>
                <div class="down">REGISTRATION SUCCESSFUL</div>
              </div>
              <div class="right" />
            </div>
            <div class="subTitle titleTop">
              <div class="name">验证类型</div>
              <div class="value">{{ passInfo.beInvite ? '邀约验证' : '身份验证' }}</div>
              <svg-icon v-if="meetingInfo.signStatus === 'SIGNIN'" icon-class="sign_in_green" class="signSvg" />
            </div>
            <div class="subTitle titleTop">
              <div class="name">验证码</div>
              <div class="value">{{ passInfo.beInvite ? passInfo.askCode : passInfo.phone }}</div>
            </div>
            <div class="tips">
              <p>温馨提示：</p>
              <p>1、来访当天请先到前台/自助机出示身份证验证通过后即可获得通行凭证；</p>
              <p v-if="meetingInfo.remark">2、{{ meetingInfo.remark }}</p>
            </div>
            <div v-if="meetingInfo.signStatus === 'UNSIGNIN'" class="doubleBtn">
              <div class="cancel" v-if="filterCancel()" :style="meetingInfo.signType !== 'ACCESS_AUTOMATIC_SIGN' ? 'width: 48%' : 'width: 100%'" @click="onCancel">
                取消
              </div>
              <div v-if="meetingInfo.signType !== 'ACCESS_AUTOMATIC_SIGN'" :style="meetingInfo.cancelAttendee ? 'width: 48%' : 'width: 100%'" class="sign" @click="onSign">
                签到
              </div>
            </div>
          </div>
          <div v-else class="item">
            <div class="content">
              <div class="left" />
              <div>
                <div class="up">登记成功</div>
                <div class="down">REGISTRATION SUCCESSFUL</div>
              </div>
              <div class="right" />
            </div>
            <div class="subTitle">
              <div class="name">通行方式</div>
              <div class="value">{{ passInfo.authName }}</div>
              <svg-icon v-if="meetingInfo.signStatus === 'SIGNIN'" icon-class="sign_in_green" class="signSvg" />
            </div>
            <div v-if="passInfo.qrCode" class="imageArea">
              <img :src="passInfo.qrCodeImgUrl" alt="" style="width: 100%; object-fit: cover;">
              <div class="refresh">
                <button class="refreshBtn" @click="refreshQrCode"><van-icon name="replay" /></button>
              </div>
            </div>
            <div v-else>
              <div
                  v-if="!passInfo.faceImg"
                  class="upload_btn"
                  @click="showFaceUpload = true"
              >
                <van-icon name="plus" color="#0CFFF7" />
              </div>
              <div
                  v-else
                  class="img_wrap"
              >
                <img :src="baseURL + passInfo.faceImg">
                <div
                    v-show="!uploadSuc"
                    class="btn_wrap"
                >
                  <van-button
                      size="small"
                      type="default"
                      @click="showFaceUpload = true"
                  >
                    重新选择
                  </van-button>
                  <van-button
                      size="small"
                      type="info"
                      @click="handleCommit"
                  >提交</van-button>
                </div>
              </div>
            </div>
            <div class="tips">
              <p>温馨提示：</p>
              <p>1、动态二维码仅限个人使用，3分钟有效，超时后刷新即可使用</p>
              <p v-if="passInfo.remark">2、{{ passInfo.remark }}</p>
            </div>
            <div v-if="meetingInfo.signStatus === 'UNSIGNIN'" class="doubleBtn">
              <div v-if="filterCancel()" class="cancel" :style="meetingInfo.signType !== 'ACCESS_AUTOMATIC_SIGN' ? 'width: 48%' : 'width: 100%'" @click="onCancel">
                取消
              </div>
              <div v-if="meetingInfo.signType !== 'ACCESS_AUTOMATIC_SIGN'" :style="meetingInfo.cancelAttendee ? 'width: 48%' : 'width: 100%'" class="sign" @click="onSign">
                签到
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <van-popup v-model="showUpload">
      <div class="upload">
        <h5>拍照示例</h5>
        <div class="right_img">
          <img
            alt
            src="../../../assets/img/img.png"
          >
        </div>
        <p class="tip_text">
          温馨提示：为保证审核顺利通过，请保持人脸完整清晰，勿用美颜。
        </p>
        <div class="wrong_img">
          <div>
            <img alt src="../../../assets/img/img1.png">
            <p>照片模糊</p>
          </div>
          <div>
            <img alt src="../../../assets/img/img2.png">
            <p>比例过小</p>
          </div>
          <div>
            <img alt src="../../../assets/img/img3.png">
            <p>人脸不完整</p>
          </div>
          <div>
            <img alt src="../../../assets/img/img4.png">
            <p>侧脸拍照</p>
          </div>
        </div>
        <van-uploader :after-read="afterRead">
          <van-button type="info" style="display: flex; justify-content: center">
            <svg-icon icon-class="album" />从相册选择
          </van-button>
        </van-uploader>
        <van-uploader
          capture="camera"
          :after-read="afterRead"
        >
          <van-button type="default" style="display: flex; justify-content: center">
            <svg-icon icon-class="picture" />拍照
          </van-button>
        </van-uploader>
      </div>
    </van-popup>
    <van-popup v-model="showFaceUpload">
      <div class="upload">
        <h5>拍照示例</h5>
        <div class="right_img">
          <img
            alt
            src="../../../assets/img/img.png"
          >
        </div>
        <p class="tip_text">
          温馨提示：为保证审核顺利通过，请保持人脸完整清晰，勿用美颜。
        </p>
        <div class="wrong_img">
          <div>
            <img alt src="../../../assets/img/img1.png">
            <p>照片模糊</p>
          </div>
          <div>
            <img alt src="../../../assets/img/img2.png">
            <p>比例过小</p>
          </div>
          <div>
            <img alt src="../../../assets/img/img3.png">
            <p>人脸不完整</p>
          </div>
          <div>
            <img alt src="../../../assets/img/img4.png">
            <p>侧脸拍照</p>
          </div>
        </div>
        <van-uploader :after-read="afterReadFace">
          <van-button type="info" style="display: flex; justify-content: center">
            <svg-icon icon-class="album" />从相册选择
          </van-button>
        </van-uploader>
        <van-uploader
          capture="camera"
          :after-read="afterReadFace"
        >
          <van-button type="default" style="display: flex; justify-content: center">
            <svg-icon icon-class="picture" />拍照
          </van-button>
        </van-uploader>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import config from '@/common/config';
import Clipboard from 'clipboard';
import { faceAuth, faceUpdate, getCode } from '@/api/home'
import fileUtils from '@/utils/fileUtils';
import lrz from 'lrz';
import { Upload } from '@/api/user';
export default {
  name: 'GREEN',
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  filters: {
    agendaClass(val) {
      if (val % 2 === 0) {
        return 'item itemLeft';
      } else {
        return 'item ';
      }
    },
    filterLine(val, length) {
      const num = length - (length % 2 === 0 ? 2 : 1);
      if (val === num) {
        return 'lineEnd';
      } else if (val === 0) {
        return 'lineStart';
      } else {
        return 'line';
      }
    },
    filterValue(val, index) {
      if (val) {
        if (index % 2 === 0) {
          return 'valueLeft';
        } else {
          return 'valueRight';
        }
      } else {
        return '';
      }
    },
    filterGender(gender, val) {
      const value = val === 'MALE' ? 'boy ' : 'girl ';
      if (val === gender) {
        return value + 'genderSelect';
      } else {
        return value;
      }
    }
  },
  props: {
    meetingInfo: {
      type: Object,
      required: true,
      default: () => {
        return {
          agendasList: [],
          infoList: [],
          materials: []
        };
      }
    },
    passInfo: {
      type: Object,
      required: true,
      default: {}
    },
    dataForm: {
      type: Object,
      required: true,
      default: () => {
        return {
          gender: 'MALE',
          meetingId: '',
          attendee: '',
          phone: '',
          validCode: '',
          company: '',
          carNumber: '',
          faceImg: ''
        };
      }
    },
    uploadSuc: {
      type: Boolean,
      required: true,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      baseURL: process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro,
      showUpload: false,
      viewStatus: false,
      showFaceUpload: false,
      codeFlag: true,
      countDown: 60,
      btnName: '获取验证码',
      btnDefault: '重发验证码',
      showSms: true,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
        // Some Swiper option/callback...
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  created() {
    this.viewStatus = this.$route.query.view;
  },
  methods: {
    onGender(val) {
      this.dataForm.gender = val;
    },
    onCopy(e) {
      const baseURL = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;
      const url = baseURL + e;
      const clipboard = new Clipboard('.tag', {
        text: function() {
          return url;
        }
      });
      clipboard.on('success', e => {
        this.$toast({
          message: '复制成功，请在浏览器打开'
        });
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        this.$toast({
          message: '复制失败'
        });
        clipboard.destroy();
      });
    },
    checkPhone() {
      let phone;
      if (this.dataForm.phone == '') {
        phone = false;
        this.$toast('请输入手机号');
      } else if (!(/^1[3456789]\d{9}$/.test(this.dataForm.phone))) {
        this.$toast('手机号格式错误，请检查');
        phone = false;
      } else {
        this.phonErrMsg = '';
        phone = true;
      }
      return phone;
    },
    GetCode() {
      if (this.viewStatus) {
        return;
      }
      // 函数节流
      if (!this.checkPhone()) {
        return;
      }
      if (!this.codeFlag) return;
      this.codeFlag = false;
      // 修改按钮名称
      this.btnName = '发送中...';
      const data = { phone: this.dataForm.phone };
      getCode(data).then(res => {
        // 发送成功
        let _time = this.countDown;
        this.codeInterval = setInterval(() => {
          _time -= 1;
          this.btnName = _time.toString() + 's';
          if (_time <= 0) {
            clearInterval(this.codeInterval);
            // 修改按钮名称
            this.btnName = this.btnDefault;
            // 恢复函数节流
            this.codeFlag = true;
          }
        }, 1000);
      }).catch(err => {
        this.btnName = this.btnDefault;
        this.codeFlag = true;
      });
    },
    afterRead(file) {
      if (this.viewStatus) {
        this.showUpload = false;
        return;
      }
      const that = this;
      fileUtils.getOrientation(file.file).then((orient) => {
        lrz(file.file, { width: 1024 }).then(rst => {
          const fromData = new FormData();
          // 此时可以自行将文件上传至服务器
          let angle = '0';
          switch (orient) { // Orientation 拍摄方向,旋转角度
            case 6: // 顺时针90°
              angle = '90';
              break;
            case 3: // 逆时针90°
              angle = '180';
              break;
            case 8: // 180°
              angle = '270';
              break;
          }
          fromData.append('file', rst.origin);
          fromData.append('angle', angle);
          // this.$toast.loading({
          //   message: '上传中...',
          //   forbidClick: true,
          //   loadingType: 'spinner',
          //   duration: 0
          // });
          Upload(fromData).then(res => {
            this.$toast.clear();
            that.dataForm.faceImg = res.data;
          }).catch(err => {
            console.log(err);
            setTimeout(() => { this.$toast.clear(); }, 3000);
          });
          this.showUpload = false;
          this.show = false;
        });
      });
    },
    afterReadFace(file) {
      const that = this;
      fileUtils.getOrientation(file.file).then((orient) => {
        lrz(file.file, { width: 1024 }).then(rst => {
          const fromData = new FormData();
          // 此时可以自行将文件上传至服务器
          let angle = '0';
          switch (orient) { // Orientation 拍摄方向,旋转角度
            case 6: // 顺时针90°
              angle = '90';
              break;
            case 3: // 逆时针90°
              angle = '180';
              break;
            case 8: // 180°
              angle = '270';
              break;
          }
          fromData.append('file', rst.origin);
          fromData.append('angle', angle);
          // this.$toast.loading({
          //   message: '上传中...',
          //   forbidClick: true,
          //   loadingType: 'spinner',
          //   duration: 0
          // });
          Upload(fromData).then(res => {
            this.$toast.clear();
            that.passInfo.faceImg = res.data;
          }).catch(err => {
            console.log(err);
            setTimeout(() => { this.$toast.clear(); }, 3000);
          });
          this.showFaceUpload = false;
        });
      });
    },
    confirmMeeting() {
      if (!this.viewStatus) {
        this.$emit('meetingApply', this.dataForm);
      }
    },
    refreshQrCode() {
      this.$emit('refreshQrCode');
    },
    onSign() {
      this.$emit('onSign');
    },
    onCancel() {
      this.$emit('onCancel');
    },
    onChangePhone() {
      const personalInfo = localStorage.getItem('personalInfo');
      if (personalInfo) {
        const info = JSON.parse(personalInfo);
        if (info.phone !== this.dataForm.phone) {
          this.showSms = true;
        } else {
          this.showSms = false;
        }
      }
    },
    handleCommit() {
      const data = {
        id: this.passInfo.id,
        faceImg: this.passInfo.faceImg
      };
      if (this.meetingInfo.personType === 'STAFF') { // faceUpdate
        faceUpdate(data).then(res => {
          this.uploadSuc = true;
          this.$toast({
            message: '提交成功!来访当天刷脸通行即可'
          });
          this.$emit('refreshUploadSuc', true);
          // this.headerTip = '提交成功!来访当天刷脸通行即可'
          // this.clickFlag = true
        }).catch(() => {
          // this.clickFlag = true
        });
      } else {
        faceAuth(data).then(res => {
          this.uploadSuc = true;
          this.$toast({
            message: '提交成功!来访当天刷脸通行即可'
          });
          this.$emit('refreshUploadSuc', true);
          // this.headerTip = '提交成功!来访当天刷脸通行即可'
          // this.clickFlag = true
        }).catch(() => {
          // this.clickFlag = true
        });
      }
    },
    filterSign() {
      const { apply } = this.meetingInfo;
      return !apply;
    },
    filterCancel() {
      const { cancelAttendee } = this.meetingInfo;
      return cancelAttendee;
    },
    filterTitle(name) {
      if (name.length > 15) {
        return name.substring(0, 15) + '...' + name.substring(name.lastIndexOf('.') + 1);
      } else {
        return name;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}
.invitations {
  height: 100%;
  max-width: 100%;
  background-size: cover;
  background-image: url("../../../assets/img/invitations_bg_2.png");
  position: relative;

  .swiper-wrapper {
    height: 100%;

    .step1 {
            padding-bottom: 0.1rem;
      overflow: scroll;

      .status {
        .svg-icon {
          position: absolute;
          right: 0;
          font-size: 0.85rem;
        }
      }

      .content {
        .change_val(padding-top, 10);
        display: flex;
        justify-content: center;
        flex-direction: column;
        .head {
          display: flex;
          justify-content: center;
          .change_val(margin-top, 172);
          .svg-icon {
            font-size: 2.55rem;
          }
        }

        .theme {
          text-align: center;
          .change_val(font-size, 48);
          .change_val(margin-top, 149);
          color: #FFFFFF;
        }

        .footer {
          width: 100%;
          display: flex;
          justify-content: center;
          .change_val(margin-top, 128);

          .box {

            .item {
              display: flex;
              align-items: center;
              .svg-icon {
                font-size: 0.15rem;
              }
              .value {
                .change_val(font-size, 28);
                .change_val(margin-left, 26);
                color: #FFFFFF;
              }
              .organization {
                .change_val(font-size, 28);
                .change_val(margin-top, 28);
                color: #FFFFFF;
              }
            }

            .address {
              .change_val(margin-top, 36);
            }
          }

        }
      }
    }

    .step2 {
            padding-bottom: 0.1rem;
      overflow: scroll;

      .content {
        display: flex;
        justify-content: center;
        color: #0CFFF7;
        .change_val(margin, 80);
        .change_val(font-size, 41);

        .left {
          .change_val(width, 50);
          border-top: 1px solid #0CFFF7;
          border-bottom: 1px solid #0CFFF7;
          border-left: 1px solid #0CFFF7;
        }

        .up {
          text-align: center;
          font-weight: 400;
          .change_val(margin-top, -28);
        }

        .down {
          .change_margin(padding, 10, 20);
          .change_val(font-size, 19);
          text-align: center;
          border-bottom: 1px solid #0CFFF7;
        }
        .right {
          .change_val(width, 50);
          border-top: 1px solid #0CFFF7;
          border-bottom: 1px solid #0CFFF7;
          border-right: 1px solid #0CFFF7;
        }
      }

      .value {
        .change_margin(padding, 0, 82);
        .change_val(font-size, 32);
        .change_val(line-height, 54);
        color: #FFFFFF;
        font-weight: 400;
      }

      .footer {
        .change_margin(padding, 0, 82);
        .change_val(margin-top, 98);
        .change_val(font-size, 28);
        color: #FFFFFF;
        font-weight: 400;

        .company {
          .change_val(margin-top, 28);
        }
      }
    }

    .step3 {
      padding-bottom: 0.1rem;
      overflow: scroll;

      .content {
        display: flex;
        justify-content: center;
        color: #0CFFF7;
        .change_val(margin, 80);
        .change_val(font-size, 41);

        .left {
          .change_val(width, 50);
          border-top: 1px solid #0CFFF7;
          border-bottom: 1px solid #0CFFF7;
          border-left: 1px solid #0CFFF7;
        }

        .up {
          text-align: center;
          font-weight: 400;
          .change_val(margin-top, -28);
        }

        .down {
          .change_margin(padding, 10, 20);
          .change_val(font-size, 19);
          text-align: center;
          border-bottom: 1px solid #0CFFF7;
        }
        .right {
          .change_val(width, 50);
          border-top: 1px solid #0CFFF7;
          border-bottom: 1px solid #0CFFF7;
          border-right: 1px solid #0CFFF7;
        }
      }

      .list {
        display: flex;
        flex-direction: column;
        width: 100%;
        .change_val(padding-bottom, 48);

        .dialog {
          display: flex;
          position: relative;
          .change_val(height, 108);
          .change_margin(margin, 0, 20);
          .change_margin(padding, 20, 80);

          .line_up {
            position: absolute;
            top: 0;
            .change_val(left, 90);
            .change_val(height, 64);
            .change_val(width, 2);
            border-left: 1px dashed  #0CFFF7;
          }

          .line_down {
            position: absolute;
            bottom: 0;
            .change_val(left, 90);
            .change_val(height, 64);
            .change_val(width, 2);
            border-left: 1px dashed  #0CFFF7;
          }

          .line_icon {
            .change_val(margin-right, 30);
            display: flex;
            align-items: center;

            .lineSvg {
              .change_val(height, 24);
              .change_val(width, 24);
            }
          }

          .horn {
            display: flex;
            flex-direction: column;
            .change_val(margin-right, -3);
            .up {
              .change_val(height, 38);
              .change_val(margin-top, 4);
              border-right: 1px solid #0CFFF7;
            }

            .arrow {
              position: relative;
              .change_val(height, 24);

              .arrow-icon {
                position: absolute;
                .change_val(right, -8);
                .change_val(top, 3);
                //top: .18rem;
                position: absolute;
                transform: rotate(-45deg);
                //width: .25rem;
                //height: .25rem;
                .change_val(width, 17);
                .change_val(height, 17);
                border-width: 1px 0rem 0rem 1px;
                border-style: solid;
                border-color:#0CFFF7;
                background: #000;
                background: hsla(0, 0, 0, 0);
              }
            }

            .down {
              .change_val(height, 42);
              border-right: 1px solid #0CFFF7;
            }
          }

          .item {
            border-top: 1px solid #0CFFF7;
            border-right: 1px solid #0CFFF7;
            border-bottom: 1px solid #0CFFF7;
            border-radius: 5px;
            .change_val(height, 108);
            .change_val(font-size, 30);
            .change_margin(padding, 0, 20);
            display: flex;
            align-items: center;
            color: #FFFFFF;
          }

        }

        //.item {
        //  .change_val(font-size, 30);
        //  .change_val(padding, 30);
        //  width: 35%;
        //  color: #FFFFFF;
        //  position: relative;
        //
        //  .valueLeft {
        //    border: 1px solid #0CFFF7;
        //    border-radius: 4px;
        //    .change_val(padding, 15);
        //    .change_val(margin-right, 15);
        //    position: relative;
        //    .svg-icon {
        //      position: absolute;
        //      top: 50%;
        //      transform: translateY(-50%);
        //      right: -16px;
        //      margin: 0 auto;
        //    }
        //  }
        //
        //  .valueRight {
        //    border: 1px solid #0CFFF7;
        //    border-radius: 3px;
        //    .change_val(padding, 20);
        //    .change_val(margin-left, 15);
        //    position: relative;
        //
        //    .svg-icon {
        //      position: absolute;
        //      top: 65%;
        //      transform: translateY(-65%);
        //      left: -12px;
        //      margin: 0 auto;
        //    }
        //  }
        //
        //}
        //
        //.itemLeft {
        //}
        //
        //.line {
        //  position: absolute;
        //  border-right: 1px dashed #0CFFF7;
        //  right: -1px;
        //  top: 0;
        //  height: 100%;
        //}
        //
        //.lineStart {
        //  position: absolute;
        //  border-right: 1px dashed #0CFFF7;
        //  right: -1px;
        //  bottom: 0;
        //  height: 50%;
        //}
        //
        //.lineEnd {
        //  position: absolute;
        //  border-right: 1px dashed #0CFFF7;
        //  right: -1px;
        //  top: 0;
        //  height: 50%;
        //}
        //
        //.svg {
        //  position: absolute;
        //  right: -8px;
        //  top: 40%;
        //  bottom: 40%;
        //}
      }
    }

    .step4 {
            padding-bottom: 0.1rem;
      overflow: scroll;

      .content {
        display: flex;
        justify-content: center;
        color: #0CFFF7;
        .change_val(margin, 80);
        .change_val(font-size, 41);

        .left {
          .change_val(width, 50);
          border-top: 1px solid #0CFFF7;
          border-bottom: 1px solid #0CFFF7;
          border-left: 1px solid #0CFFF7;
        }

        .up {
          text-align: center;
          font-weight: 400;
          .change_val(margin-top, -28);
        }

        .down {
          .change_margin(padding, 10, 20);
          .change_val(font-size, 19);
          text-align: center;
          border-bottom: 1px solid #0CFFF7;
        }
        .right {
          .change_val(width, 50);
          border-top: 1px solid #0CFFF7;
          border-bottom: 1px solid #0CFFF7;
          border-right: 1px solid #0CFFF7;
        }
      }

      .list {
        display: flex;
        flex-direction: column;
        .item {
          display: flex;
          justify-content: center;
          flex-direction: column;
          .change_val(margin-top, 33);

          .name {
            display: flex;
            justify-content: center;
            span {
              .change_val(width, 325);
              .change_val(font-size, 28);
              .change_margin(padding, 9, 0);
              text-align: center;
              background: rgba(255, 255, 255, 0.17);
              border: 1px solid #0CFFF7;
              opacity: 1;
              font-weight: 500;
              color: #0CFFF7;
            }
          }
          .value {
            .change_val(font-size, 24);
            .change_val(margin-top, 34);
            text-align: center;
            color: #FFFFFF;
          }

          .organization {
            display: flex;
            justify-content: center;
            align-items: center;
            .change_val(font-size, 24);
            text-align: center;
            color: #FFFFFF;

            .tag {
              .change_val(margin-left, 20);
            }
          }
        }
      }
    }

    .step5 {
            padding-bottom: 0.1rem;
      overflow: scroll;

      .content {
        display: flex;
        justify-content: center;
        color: #0CFFF7;
        .change_val(margin, 80);
        .change_val(font-size, 41);

        .left {
          .change_val(width, 50);
          border-top: 1px solid #0CFFF7;
          border-bottom: 1px solid #0CFFF7;
          border-left: 1px solid #0CFFF7;
        }

        .up {
          text-align: center;
          font-weight: 400;
          .change_val(margin-top, -28);
        }

        .down {
          .change_margin(padding, 10, 20);
          .change_val(font-size, 19);
          text-align: center;
          border-bottom: 1px solid #0CFFF7;
        }
        .right {
          .change_val(width, 50);
          border-top: 1px solid #0CFFF7;
          border-bottom: 1px solid #0CFFF7;
          border-right: 1px solid #0CFFF7;
        }
      }

      .form {
        display: flex;
        flex-direction: column;
        align-items: center;

        .item {
          .change_val(width, 526);
          .change_val(margin-bottom, 48);

          input{
            background:none;
            outline:none;
            color: #FFFFFF;
            border: 1px solid #0CFFF7;
            background: rgba(37, 218, 251, 0.17);
            .change_margin(padding, 5, 18);
          }
          input::-webkit-input-placeholder {
            /* placeholder颜色  */
            color: rgba(255, 255, 255, 0.7);
          }
          .label {
            .change_val(font-size, 28);
            color: #FFFFFF;
            span {
              color: #F76260;
            }
          }
          .formItem {
            display: flex;
            .change_val(margin-top, 8);
            .nameInput {
              .change_val(width, 417);
            }
            .phoneInput {
              width: 100%;
            }
            .gender {
              display: flex;
              .change_val(margin-left, 13);

              .boy {
                .change_margin(padding, 9, 11);
                border-top: 1px solid #0CFFF7;
                border-left: 1px solid #0CFFF7;
                border-bottom: 1px solid #0CFFF7;
                cursor: pointer;
                color: #0CFFF7;
              }

              .girl {
                .change_margin(padding, 9, 11);
                border-top: 1px solid #0CFFF7;
                border-right: 1px solid #0CFFF7;
                border-bottom: 1px solid #0CFFF7;
                cursor: pointer;
                color: #0CFFF7;
              }

              .genderSelect {
                background-color: #0CFFF7;
                color: #00307C;
              }
            }
            .btn {
              .change_val(margin-left, 19);
              width: 100%;
              background: #0CFFF7;
              border: 1px solid #0CFFF7;
              color: #00307C;
            }
          }
          .uploadBtn {
            .change_val(font-size, 28);
            .change_margin(padding, 4, 0);
            .change_val(margin-top, 8);
            width: 100%;
            background: rgba(37, 218, 251, 0.17);
            border: 1px solid #0CFFF7;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            span {
              .change_val(margin-right, 11);
            }
          }
          .confirmBtn {
            .change_margin(padding, 4, 0);
            .change_val(font-size, 28);
            width: 100%;
            background: #0CFFF7;
            border: 1px solid #0CFFF7;
            opacity: 1;
            border-radius: 2px;
            color: #00307D;
          }
          .img {
            width: 50%;
            position: relative;
            .del {
              position: absolute;
              .change_val(width, 42);
              .change_val(top, 21);
              .change_val(right, -21);
            }
            img {
              width: 100%;
              .change_val(margin-top, 30);
            }
          }

        }

      }

      .qrCode {
        display: flex;
        justify-content: center;
        .item {
          //.change_val(width, 526);
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          .subTitle {
            .change_val(width, 526);
            display: flex;
            justify-content: space-between;
            position: relative;
            .name {
              .change_val(font-size, 28);
              font-weight: 500;
              color: #FFFFFF;
            }

            .value {
              .change_val(font-size, 24);
              font-weight: 500;
              color: #FFFFFF;
            }

            .signSvg {
              position: absolute;
              .change_val(width, 240);
              .change_val(height, 248);
              .change_val(top, -140);
              right: 0;
            }
          }

          .imageArea {
            .change_val(margin-top, 26);
            position: relative;

            .refresh {
              display: flex;
              justify-content: flex-end;
              position: absolute;
              bottom: 10px;
              right: 5px;
              .refreshBtn {
                .change_margin(padding, 10, 10);
                .change_val(font-size, 28);
                background: #0CFFF7;
                border: 1px solid #0CFFF7;
                opacity: 1;
                border-radius: 2px;
                color: #00307D;
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }

          }

          .titleTop {
            .change_val(margin-bottom, 28);
          }

          .tips {
            .change_val(width, 526);
            .change_val(font-size, 24);
            .change_val(line-height, 43);
            font-weight: 400;
            color: #FFFFFF;
          }


          .doubleBtn {
            .change_val(width, 526);
            .change_val(margin-top, 82);
            .change_val(font-size, 28);
            display: flex;
            justify-content: space-between;

            .cancel {
              border: 1px solid #0CFFF7;
              .change_margin(padding, 10, 0);
              width: 48%;
              border-radius: 2px;
              color: #0CFFF7;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
            }

            .sign {
              border: 1px solid #0CFFF7;
              .change_margin(padding, 4, 0);
              width: 48%;
              border-radius: 2px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #00307D;
              background: #0CFFF7;
              cursor: pointer;
            }
          }

          .upload_btn {
            width: 1rem;
            height: 1rem;
            border: 1px dashed #0CFFF7;
            margin: 0.4rem auto;
            display: flex;
            justify-content: center;
            align-items: center;
            .van-icon {
              font-size: 0.2rem;
            }
          }

          .img_wrap {
            margin-top: 0.2rem;
            display: flex;
            justify-content: center;
            flex-direction: column;
            img {
              width: 80%;
              height: auto;
              margin: auto;
            }
          }
          .btn_wrap {
            display: flex;
            justify-content: space-between;
            width: 60%;
            margin: 0.2rem auto 0.05rem auto;
            .van-button {
              border-radius: 0.04rem;
              width: 0.7rem;
            }
          }
        }
      }
    }
  }
}
</style>
